import React from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { Button, Flex, Icon, Menu, MenuButton, MenuList } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function PopupMenu({ children, title, colorScheme, minWidth = 'auto' }) {
  const popupStyles = colorScheme === 'black'
    ? {
      bgColor: 'greyScale.900',
      color: 'white',
      hoverBg: 'greyScale.600'
    }
    : {
      bgColor: 'white',
      color: 'greyScale.900',
      hoverBg: 'greyScale.400'
    };

  return (
    <Menu>
      {({ isOpen }) => (
        <>
          <MenuButton
            _hover={{ background: popupStyles.hoverBg }}
            as={Button}
            backgroundColor={popupStyles.bgColor}
            color={popupStyles.color}
            minW={minWidth}
            variant="unstyled"
          >
            <Flex alignItems="center" justifyContent="space-between" px="16px" w="100%">
              {title}
              <Icon
                as={isOpen ? FaChevronUp : FaChevronDown}
              />
            </Flex>
          </MenuButton>
          <MenuList>
            {children}
          </MenuList>
        </>
      )}
    </Menu>
  );
}

PopupMenu.propTypes = {
  /** Text displayed on trigger button */
  title: PropTypes.string.isRequired,
  /** Color scheme for button. Can be black or white */
  colorScheme: PropTypes.string,
  /** Will consist of menu items */
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  /** Minimum width for button */
  minWidth: PropTypes.string
};

export default PopupMenu;
